import React from "react";

function EmptyTodos() {
    return(
        <p>Agrega un to-do!</p>
    );
}

export { EmptyTodos }